import { render, staticRenderFns } from "./assessmentReview.vue?vue&type=template&id=1d54d7f9&scoped=true"
import script from "./assessmentReview.vue?vue&type=script&lang=js"
export * from "./assessmentReview.vue?vue&type=script&lang=js"
import style0 from "./assessmentReview.vue?vue&type=style&index=0&id=1d54d7f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54d7f9",
  null
  
)

export default component.exports